import { render, staticRenderFns } from "./FAQsComponent.vue?vue&type=template&id=c6c7778a"
import script from "./FAQsComponent.vue?vue&type=script&lang=js"
export * from "./FAQsComponent.vue?vue&type=script&lang=js"
import style0 from "./FAQsComponent.vue?vue&type=style&index=0&id=c6c7778a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports